import { BaseModel } from "sjs-base-model";
import ImportoConIntermediariModel from "stores/lookup/models/ImportoConIntermediariModel";
import QuoteSocietaModel from "stores/lookup/models/QuoteSocietaModel";
export default class RichiestaAdeguataVerificaRequestModel extends BaseModel {
    public readonly idUtente: number = 0;
    public readonly idRichiesta?: number = 0;
    public readonly isSospensione?: boolean = false;
    public readonly step?: string = "";
    public readonly numeroNucleoFamiliare:string = "";    
    public readonly fgClienteTitolareQuoteSoc: boolean = false;
    public readonly infoTitolareRapp: string = "";
    public readonly fgAltriIntermediari: boolean = false;
    public readonly fgFamiliariClienti: boolean = false;
    public readonly nomeFamiliareCliente: string = "";
    public readonly isClienteBanca: boolean = false;
    public readonly isClienteAgenzia: boolean = false;
    public readonly isNewCliente: boolean = false;
    public readonly isCelibeNubile: boolean = false;
    public readonly isConvivente: boolean = false;
    public readonly isConiugato: boolean = false;
    public readonly isDivorziatoSeparato: boolean = false;
    public readonly isVedovo: boolean = false;
    public readonly isComunioneDeiBeni: boolean = false;
    public readonly isSeparazioneDeiBeni: boolean = false;
    public readonly isTitolareFinanziamento: boolean = false;
    public readonly isnoPEP: boolean = false;
     public readonly isEsecutoreFinanziamento: boolean = false;
     public readonly isCqs: boolean = false;
     public readonly isDlg: boolean = false;
     public readonly isCqp: boolean = false;
     public readonly isAnticipoFinanziamento: boolean = false;
     public readonly isAcquistoBeni: boolean = false;
     public readonly isEsigenzePersonali: boolean = false;
    public readonly isAltroScopoFinanziamento: boolean = false;
    public readonly scopoFinanziamentoAltro: string = "";
    public readonly quoteSoc?: QuoteSocietaModel = undefined; 
    public readonly importoIntermediari?: ImportoConIntermediariModel = undefined;


    constructor(data: Partial<RichiestaAdeguataVerificaRequestModel>) {
        super();

        this.update(data);
    }
}
